import { render, staticRenderFns } from "./v-datetime-picker.vue?vue&type=template&id=5d3c6c27&scoped=true&"
import script from "./v-datetime-picker.vue?vue&type=script&lang=js&"
export * from "./v-datetime-picker.vue?vue&type=script&lang=js&"
import style0 from "./v-datetime-picker.vue?vue&type=style&index=0&id=5d3c6c27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3c6c27",
  null
  
)

export default component.exports